<label for="feature_{{feature.id}}">
  {{ feature.header }}@if (feature.unitHeader) {
  <span>, {{ feature.unitHeader }}</span>
}
@if (isRequired()) {
  <span> *</span>
}
@if (feature.comment) {
  <span nbTooltip="{{feature.comment}}">
    <tui-icon icon="lightbulb"/>
  </span>
}
</label>

<div class="accordion-item__right">
  <form [formGroup]="form" style="width: 100%;">
    <tui-editor id="feature_{{feature.id}}"
      formControlName="featureValue"
      [style.max-height.px]="maxHtmlContentLength"
      />
    @if (featureValue.invalid && (featureValue.dirty || featureValue.touched)) {
      <div>
        @if (featureValue.hasError('required')) {
          <div class="text-danger" i18n="@@FeatureValueRequiredError">
        Поле обязательно для заполнения
      </div>
        }
        @if (featureValue.hasError('minlength')) {
          <div class="text-danger" i18n="@@FeatureValueMinLengthError">
        Минимум {{ featureValue.errors.minlength.requiredLength }} символов
      </div>
        }
        @if (featureValue.hasError('maxlength')) {
          <div class="text-danger" i18n="@@FeatureValueMaxLengthError">
        Превышен лимит символов: {{ featureValue.errors.maxlength.actualLength }} из {{ featureValue.errors.maxlength.requiredLength }}
      </div>
        }
      </div>
    }
  </form>
  <div class="accordion-item__right-info">
    @if (feature.fromMasterCard) {
      <div class="state-master-card" i18n-nbTooltip="@@FeatureFromMasterCard" nbTooltip="Характеристика заполнена из мастер карты">
        <tui-icon icon="credit-card"/>
      </div>
    }
    @if (featureValue.valid && isShowEmptyWarning()) {
      <div class="state-warn">
        <tui-icon icon="triangle-alert"/>
      </div>
    }
    @if (featureValue.invalid) {
      <div class="state-err">
        <tui-icon icon="circle-alert"/>
      </div>
    }
    @if (featureValue.valid && !isEmpty()) {
      <div class="state-success">
        <tui-icon icon="check"/>
      </div>
    }

    @if (featureLink) {
      <a [routerLink]="['/cabinet/pim/feature/edit/', feature.featureId]"
        class="entityID"
        target="_blank"
        i18n-nbTooltip="@@OpenFeatureInNewWindow"
        nbTooltip="Открыть характеристику в новом окне"
        >
        #{{ feature.featureId }}
      </a>
    }
    @if (showRemoveButton) {
      <button nbButton ghost size="tiny" status="danger" (click)="removeEvent.emit()" nbTooltip="Удалить характеристику МК" i18n-nbTooltip="@@DeleteMasterCardFeature">
        <tui-icon icon="trash-2"/>
      </button>
    }
  </div>
</div>
